import { useFetch } from 'api';
import { PlayItemData } from 'types';
import { SignInButton } from 'components';
import { Loader } from 'components/ui';
import { utcOffset } from 'utils';
import PlayItem from './PlayItem';

import styles from './PlayList.module.scss';

const PlayList = () => {
  const { data } = useFetch<PlayItemData[]>(`/v1/webapp/liveGames?${utcOffset()}`);

  return (
    <div className={styles.playList}>
      {data ? (
        <>
          <div className={styles.header}>
            <SignInButton />
          </div>

          <div className={styles.content}>
            {data.map(item => (
              <PlayItem key={item.game} data={item} />
            ))}
          </div>
        </>
      ) : null}

      <Loader visible={!data} className={styles.loader} />
    </div>
  );
};

export default PlayList;
